<template>
    <div>
        <ThatsTable class="inventory-by-warehouse-grid" title="Items" ref="table" :multipleSelection="false" :endpoint="endpoint" :columns="columns" :newBtn="false" :copyBtn="true" @open="openNewModal" @viewSoldTo="viewSoldTo" @row-click="rowClick" @cell-value-click="handleCellValueClick" :key="tableKey" :filterFormData="filterForm" @clearFilterForm="clearFilterForm" @viewRelatedDocument="viewRelatedDocument" @tableSearchTerm="tableSearchTerm">
        <template #filter="{}">
                <ThatsAutocomplete :clearable="false" tabindex="6" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Brand" v-model="filterForm.U_PRT_BrandId" :reduce="obj => obj.code" :reduceLabel="'brand'" :options="brands" :rules="''"></ThatsAutocomplete>
                <ThatsAutocomplete :clearable="false" tabindex="10" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Collections" v-model="filterForm.U_PRT_CollectionId" :reduce="obj => obj.mdbID" :reduceLabel="'name'" :options="collections" :rules="''"></ThatsAutocomplete>
                <ThatsAutocomplete :clearable="false" tabindex="10" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Category" v-model="filterForm.U_PRT_CategoryId" :reduce="obj => obj.id" :reduceLabel="'name'" :options="filteredCategory" :rules="''"></ThatsAutocomplete>

            </template>
        
        </ThatsTable>
         <InventoryItemMasterForm ref="inventoryItemMasterForm" @success="refreshTable"></InventoryItemMasterForm>
         <InventoryByWarehouseCellDialog
            :visible.sync="cellDialogVisible"
            :row="cellDialogRow"
            :clicked-field="cellDialogField"
            :clicked-label="cellDialogLabel"
            :fields="detailFields"
            :columns="columns"
            :breakdown-type="cellDialogBreakdownType"
            @close="clearCellDialog"
         ></InventoryByWarehouseCellDialog>
    </div>
</template>
<script>
/* eslint-disable no-unused-vars */
import { mapGetters, mapMutations,mapActions } from 'vuex';
import ThatsTable from "./Table";
import { ThatsInput, ThatsAutocomplete} from '../../components/thats/Thats'
import InventoryItemMasterForm from '../inventory-item-master/InventoryItemMasterFormV2.vue'
import InventoryByWarehouseCellDialog from './InventoryByWarehouseCellDialog.vue'
export default {
        components:{
            ThatsTable,
            ThatsAutocomplete,
            InventoryItemMasterForm,
            InventoryByWarehouseCellDialog
        },
    inject : ['brandProvider','categoryProvider','areaProvider','collectionProvider','filteredCategoryProvider','materialProvider','colourMasterProvider','sizeMasterProvider'],
    provide(){
        return {

        }
    },
    data(){
        return {
            endpoint : 'item-master/displayed-items',
            bulkUpdate : 'status',
            viewTransactionLoading : 0,
            showModal:false,
            tableKey : 0,
            detailFields: [
                "wh_01",
                "drm_01",
                "sr_01",
                "sr_02",
                "sr_03",
                "sr_04",
                "sr_05",
                "sr_06",
                "sr_07",
                "sr_08",
                "sr_09",
                "sr_10",
                "sr_11",
                "sr_12",
                "sr_13",
                "git_01",
            ],
            filterForm : {
                searchTerm : null,
                SuppCatNum : null,
                U_PRT_BrandId : "ALL",
                U_PRT_CollectionId : "ALL",
                U_PRT_CategoryId : "ALL",
            },
             options: [
                { label: 'Apple', value: 'apple' },
                { label: 'Banana', value: 'banana' },
                { label: 'Orange', value: 'orange' },
            ],
            selectedValues: [],
            checkedFields: [],
            columnDefs: null,
            rowData: null,
            modelRowData: null,
            cellDialogVisible: false,
            cellDialogField: null,
            cellDialogLabel: '',
            cellDialogRow: null,
            cellDialogValue: null
        }
    },
   
    mounted(){
        const self = this;

        // console.log("onmounted")
        this.$eventBus.$on('reloadTable',function(){
            self.tableKey++
            self.setFilters();
        })
        //this.getSubCategory()
    },
    methods: {
       ...mapActions('InventoryItemMasterModule',['getRecord','getTransactions']),
       ...mapMutations('InventoryItemMasterModule',['setFormStatusUpdate','setFormStatusCreate','setEmptyForm','setFilters','setFormData']),
       ...mapMutations('InvoiceModule',{
            invoiceSetRecord : 'setFormRecord',
            invoiceStatusUpdate : 'setFormStatusUpdate',
            invoiceSetTblKey : 'setTblKey',
        }),
        ...mapActions('InvoiceModule',{
            invoiceGetRecord : 'getRecord',
            invoiceGetRecordSeries : 'getRecordSeries',
        }),
        ...mapActions('QuantityAdjustModule',['getCustomerQuotation']),

        rowClick(row){
            const self = this;

            const mergeFormData = {...this.initialFormObject,...JSON.parse(JSON.stringify(row)),connection : "QATL_PRODUCTION"}

       /*      const loading = Loading.service({
                fullscreen: true ,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            }); */
            self.setFormStatusUpdate();
            self.setFormData(mergeFormData);
            this.getRecord(mergeFormData)
            self.$refs.inventoryItemMasterForm.openDialog();
        },
        handleCellValueClick(payload){
            if (!payload || !['stock_qty', 'ordered_qty', 'committed_qty', 'in_transit_qty'].includes(payload.field)) return
            const column = Array.isArray(this.columns) ? this.columns.find(c => c.field === payload.field) : null
            this.cellDialogField = payload.field
            this.cellDialogLabel = payload.label || (column && column.label) || payload.field
            this.cellDialogRow = payload.row || null
            this.cellDialogValue = payload.value
            this.cellDialogVisible = true
        },
        clearCellDialog(){
            this.cellDialogField = null
            this.cellDialogLabel = ''
            this.cellDialogRow = null
            this.cellDialogValue = null
        },

        clearFilterForm(){
           this.filterForm = {
                searchTerm : null,
                SuppCatNum : null,
                U_PRT_BrandId : "ALL",
                U_PRT_CollectionId : "ALL",
                U_PRT_CategoryId : "ALL",
            }
        },

        viewSoldTo(obj){
            this.$refs.itemSoldToWindow.triggerGetTransaction(obj)


        },
        viewRelatedDocument(obj){
            if(obj.reference == 'under_production_qty'){
                this.$refs.relatedDocumentDialogPurchaseOrder.triggerGetTransaction(obj.row)
            }
            if(obj.reference == 'in_transit_qty'){
                this.$refs.relatedDocumentDialogIncomingContainer.triggerGetTransaction(obj.row)
            }
            if(obj.reference == 'stock'){
                this.$refs.relatedDocumentDialogHistory.triggerGetTransaction(obj.row)
            }

        },
        openNewModal(){
            this.setFormStatusCreate();
            this.setEmptyForm();
           this.$refs.inventoryItemMasterForm.openDialog();
        },
        refreshTable(){
            // //alert(1)
            // this.tableKey++
            this.$refs.table.refreshTable()

        },

        itemSoldRowClickHandler(obj){
            const self = this;
            console.log("itemSoldRowClickHandler")
            console.log(obj)
            const form  = {...obj,items : [],attachment : [],invoice : {
                        series : null,
                        date : "",
                        balance : 0,
                        paid : 0,
                        attachment : [],
                        payments : [],
                    },
                    credit_note : {
                        total : 0,
                        status : null,
                        credit_note_reference : []
                    },
                    creditnotes : [],
                    credit_note_items : [],
                    cancellation : [],
                    cancellation_item : [],
                    refund : [],
                    refund_item : [],
                    exchange : [],
                    credit_memo : [],
                    exchange_item : [],
                    enable_push : false,
                    location : null,
                    }


                    if(!form.attr.hasOwnProperty('corporate')){
                            form.attr.corporate = false
                        }
                        if(!form.attr.hasOwnProperty('contact_person')){
                            form.attr.contact_person = {
                                name : null,
                                mobile : null,
                                attr : {

                                  address: null,
                                  address2 : {
                                      street : null,
                                      building : null,
                                      zone : null,
                                      area : null,
                                      city : null,
                                  },
                                  designation : null,
                                  email : null,
                                  first_name : null,
                                  middle_name : null,
                                  last_name : null,
                                  salutation : null
                                }
                              }
                        }
                    self.invoiceStatusUpdate()
                    self.invoiceSetRecord(form)
                    self.invoiceGetRecord({token_id : obj.token_id, series : obj.series})
                    this.invoiceSetTblKey(this.salesTblKey + 1);
                    this.$refs.invoiceForm.openDialog();

        },  

        openCountryOfOriginDialog(){
            this.$refs.bulkUpdateCountryOfOrigin.openDialog();
        },
        openPrintStickerDialog(){
            this.$refs.bulkPrintQrCode.openDialog();
        },
        openBulkUpdateDialog(update){
            this.bulkUpdate = update;
            this.$refs.bulkUpdateItem.openDialog();
        },
        openBulkSyncCreateOrUpdateDialog(){
            this.$refs.bulkSyncCreateOrUpdateDialog.openDialog();
        },
        openBulkCreateQuantityDialog(){
            this.$refs.createProduct.openDialog();
        },
        openItemIntegrationDialog(){
            this.$refs.itemIntegrationDialog.openDialog();
        },
        openBulkPrintDataMatrixDialog(){
            this.$refs.bulkPrintDataMatrix.openDialog();
        },
        openPrintCatalogDialog(){
            this.$refs.printCatalog2.openDialog();
        },
        openSyncItemMasterDialog(){
            this.$refs.syncItemMaster.openDialog();
        },
        openPrintAcrylicLabelDialog(){
            this.$refs.acrylicLabel.openDialog();
        },
        openEmailSend() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        tableSearchTerm(value){
           this.filterForm.searchTerm = value
        },
        ...mapActions('InventoryItemMasterModule',['sendEmailData']),
        onSubmitEmailForm() {
            this.sendEmailData(this.emailForm)
            this.showModal = false;
            this.emailForm.email = "";
        },
        handleCommand() {
      // optional: handle when dropdown closes or a specific command is selected
        },

        handleCheckedChange() {
        this.saveColumnPrefs();
        },
        saveColumnPrefs() {
            try { localStorage.setItem(this.storageKey, JSON.stringify(this.checkedFields)); } catch(e) {}
        },
        loadColumnPrefs() {
            try {
            const raw = localStorage.getItem(this.storageKey);
            this.checkedFields = raw ? JSON.parse(raw) : [...this.allowedFields];
            } catch(e) {
            this.checkedFields = [...this.allowedFields];
            }
        },
        resetColumnPrefs() {
            try { localStorage.removeItem(this.storageKey); } catch(e) {}
            this.checkedFields = [...this.allowedFields];
        },


    },
    computed: {
        cellDialogBreakdownType(){
            if (this.cellDialogField === 'ordered_qty') return 'ordered-purchase-order'
            if (this.cellDialogField === 'committed_qty') return 'sales-order'
            if (this.cellDialogField === 'in_transit_qty') return 'in-transit'
            return null
        },

        ...mapGetters('InvoiceModule',{
            salesTblKey: 'tblKey',
        }),

        ...mapGetters('DisplayedItemsModule',['getLoading', 'initialFormObject']),
        brands : function(){
            const b = this.brandProvider();
           /*  return [...[
                {code : "0", brand : "ALL", parent : 0},
            ],...b] */


            return [...[
                {code : "ALL", brand : "ALL", parent : 0},
            ],...b];
        },

        categoryComputed : function(){
            return this.categoryProvider();
        },
        areaComputed : function(){
            return this.areaProvider();
        },

        collections : function(){
            const c = this.collectionProvider();
           /*  return [...[
                {mdbID : "0",name : "ALL", brand_id : 0},
            ],...c]; */

            if(["ALL"].includes(this.filterForm.U_PRT_BrandId)){
                return [...[
                {mdbID : "ALL",name : "ALL", brand_id : 0},
                ],...c];
            }else{
                const filteredData = c.filter((item) => item.brand_id == this.filterForm.U_PRT_BrandId,[])
                return [...[
                    {mdbID : "ALL",name : "ALL", brand_id : 0},
                ],...filteredData];
            }


        },

        filteredCategory : function(){

            const c = this.filteredCategoryProvider();

            if(["ALL"].includes(this.filterForm.U_PRT_BrandId)){
                return [...[
                {id : "ALL",name : "ALL", attributes : []},
                ],...c];
            }else{
                const filteredData = c.filter((item) => item.brands.includes(this.filterForm.U_PRT_BrandId),[])
                return [...[
                    {id : "ALL",name : "ALL", attributes : []},
                ],...filteredData];
            }
        },
        columns : function(){
            return [
                {
                    label: 'SKU/Code',
                    field: 'series',
                    sort: 'asc',
                    width : '180',
                    fixed: true,
                    clickable: true,
                    required : true

                },
                {
                    label: 'Image',
                    field: 'default_image',
                    sort: 'asc',
                    width: '100',
                    fixed: true,
                    required : true

                },

                {
                    label: 'Name',
                    field: 'name',
                    sort: 'asc',
                    clickable: true,
                    width : '300',
                    required : true
                },
                {
                    label: 'Price',
                    field: 'sale_price',
                    isAmount : true,
                    align : 'right',

                    width: '180',
                    required : true
                },
                {
                    label: 'Promo Price',
                    field: 'promo_price',
                    width: '180',
                    align : 'right',
                    isAmount : true,

                },
                {
                    label: 'Available',
                    field: 'available',
                    width: '100',
                    align : 'center',
                },
                {

                    label: 'Stock',
                    field: 'stock_qty',
                    width: '100',
                    align : 'center',

                },
               /*  {
                    label: 'Sold',
                    field: 'all_sold_qty',
                    width: '100',
                    align : 'center',
                }, */
                {
                    label: 'In Transit',
                    field: 'git_01',
                    width: '110',
                    align : 'center',
                },
              /*   {
                    label: 'Under Production',
                    field: 'under_production_qty',
                    width: '180',
                    align : 'center',
                },
                {
                    label: 'Displayed Items',
                    field: 'drm_01',
                    width: '180',
                    align : 'center',
                },
                {
                    label: 'Returned Items',
                    field: 'drm_02',
                    width: '180',
                    align : 'center',
                },
                {
                    label: 'Damaged Items',
                    field: 'drm_03',
                    width: '180',
                    align : 'center',
                },
                {
                    label: 'Goods in Transit',
                    field: 'git_01',
                    width: '180',
                    align : 'center',
                }, */
              
                {
                    label : "TLDFC",
                    field : "sr_01",
                    width : "180",
                    align : "center",
                },
                {
                    label : "BHDFC",
                    field : "sr_02",
                    width : "180",
                    align : "center",
                },
                {
                    label : "ECDFC",
                    field : "sr_03",
                    width : "180",
                    align : "center",
                },
                {
                    label : "AMDFC",
                    field : "sr_04",
                    width : "180",
                    align : "center",
                },
                {
                    label : "TADFC",
                    field : "sr_05",
                    width : "180",
                    align : "center",
                },
                {
                    label : "AHDFC",
                    field : "sr_06",
                    width : "180",
                    align : "center",
                },
                {
                    label : "BMDFC",
                    field : "sr_07",
                    width : "180",
                    align : "center",
                },
                {
                    label : "RLDFC",
                    field : "sr_08",
                    width : "180",
                    align : "center",
                },
                {
                    label : "CADFC",
                    field : "sr_09",
                    width : "180",
                    align : "center",
                },
                {
                    label : "TLKD",
                    field : "sr_10",
                    width : "180",
                    align : "center",
                },
                {
                    label : "TCPL",
                    field : "sr_11",
                    width : "180",
                    align : "center",
                },
                {
                    label : "ELDFC",
                    field : "sr_12",
                    width : "180",
                    align : "center",
                },
                {
                    label : "LAMS",
                    field : "sr_13",
                    width : "180",
                    align : "center",
                },
                {
                    label : "Warehouse",
                    field : "wh_01",
                    width : "180",
                    align : "center",
                },
                {
                    label : "Unboxed",
                    field : "drm_01",
                    width : "180",
                    align : "center",
                },

            ];
        },
        
        selectedLabels() {
            return this.options
                .filter(opt => this.selectedValues.includes(opt.value))
                .map(opt => opt.label)
        },

        allowedFields() {
            const arrayColumn = [
                "sr_01",
                "sr_02",
                "sr_03",
                "sr_04",
                "sr_05",
                "sr_06",
                "sr_07",
                "sr_08",
                "sr_09",
                "sr_10",
                "sr_11",
                "sr_12",
                "sr_13",
                "wh_01",
            ];
            return Array.isArray(this.columns) ? this.columns.filter(c => arrayColumn.includes(c.field)).map(c => c.field) : [];
        },
        isIndeterminate() {
            const len = this.checkedFields.length, total = this.allowedFields.length;
            return len > 0 && len < total;
        },
        checkAll: {
            get() {
            return this.allowedFields.length > 0 &&
                    this.checkedFields.length === this.allowedFields.length;
            },
            set(val) {
            this.checkedFields = val ? [...this.allowedFields] : [];
            this.saveColumnPrefs();
            }
        },
        storageKey() {
            return `colvis:${this.endpoint}:${this.active}`;
        }
    },

    watch : {
       /*  brandGroupComputed : function(value){
            console.log("watch brandGroupComputed")
            console.log(value)
            this.groups = [...[
                {code : "0", brand : "All", parent : 0},
            ],...value]
        }, */
       /*  brandComputed : function(value){
            console.log("watch brandComputed")
            console.log(value)
            this.brands = [...[
                {code : "0", brand : "All", parent : 0},
            ],...value]
        }, */
        categoryComputed : function(value){
          console.log("watch category")
          console.log(value)


          const uniqueCodesAndAreas = {};

            // Filter the array based on unique codes and areas
            const filteredData = value.filter(item => {
            const key = `${item.code}-${item.area}`;
            if (!uniqueCodesAndAreas[key]) {
                // If the code and area combination is not present, mark it as seen and keep the item
                uniqueCodesAndAreas[key] = true;
                return true;
            }
            // If the code and area combination is already seen, discard the item
            return false;
            },[]);

            console.log("filteredData");
            console.log(filteredData);
            console.log(value);

          this.category = [...[
                {code : "0", area : "",category : "All", attributes : []},
            ],...filteredData]
      },
      areaComputed : function(value){
          console.log("watch area")
          console.log(value)
          this.area = value
      },
     /*  collectionComputed : function(value){
          console.log("watch collectionComputed")
          console.log(value)
          this.collections = [...[
                {mdbID : "0",name : "ALL", brand_id : 0},
            ],...value]
      }, */

        "filterForm.U_PRT_BrandId" : function(){
            this.filterForm.U_PRT_CollectionId = "ALL"
            this.filterForm.U_PRT_CategoryId = "ALL"
            // this.collections = [{mdbID : "0",name : "ALL", brand_id : 0}]

        },
        "filterForm.U_PRT_CollectionId" : function(){
            this.filterForm.U_PRT_CategoryId = "ALL"
            // this.collections = [{mdbID : "0",name : "ALL", brand_id : 0}]

        },
        "filterForm.U_PRT_CategoryId" : function(){
            // this.collections = [{mdbID : "0",name : "ALL", brand_id : 0}]

        },
       

    }
}


</script>
